
import { Component, Prop, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";
import "@/store/modules/application";
const applicationState = namespace("Application");

import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import { nameInfoType } from "@/types/Application/CommonInformation";
import { yourInformationInfoDataInfoType } from '@/types/Application/CommonInformation/Pdf';
import { getLocationInfo, getYourInformationResults } from '@/components/utils/PopulateForms/PopulateCommonInformation';
import { aboutAffiantApspDataInfoType, aboutServiceApspDataInfoType } from '@/types/Application/AffidavitPersonalServicePO';
import GreyBox from "@/components/utils/PopulateForms/components/GreyBoxForm.vue";

@Component({
    components: {
        UnderlineForm,
        CheckBox,
        GreyBox
    }
})
export default class Form49Layout extends Vue {

    @Prop({ required: true })
    result!: any;

    @applicationState.State
    public applicantName!: nameInfoType;

    dataReady = false;
    existingFileNumber = '';

    yourInfo = {} as yourInformationInfoDataInfoType;
    address = '';
    servedPersonName = '';
    serviceDate = '';
    serviceTime = '';
    serviceAddress = '';
    exhibitList = [];

    idMethod = '';
    idMethodComment = '';

    mounted() {
        this.dataReady = false;
        console.log(this.result)
        this.extractInfo();
        this.dataReady = true;
    }

    public extractInfo() {
        this.getAffiantInfo();
        this.getServiceInfo();
        this.existingFileNumber = getLocationInfo(this.result.otherFormsFilingLocationSurvey);
    }

    public getAffiantInfo() {

        this.yourInfo = {} as yourInformationInfoDataInfoType;
        this.address = '';

        if (this.result?.aboutAffiantApspSurvey) {

            let aboutAffiant = {} as aboutAffiantApspDataInfoType;
            aboutAffiant = this.result.aboutAffiantApspSurvey;

            this.yourInfo = getYourInformationResults(aboutAffiant);
            const addressInfo = aboutAffiant.ApplicantAddress;

            const addressText = addressInfo.street + ', '
                + addressInfo.city + ', '
                + addressInfo.state + ', '
                + addressInfo.country + ', '
                + addressInfo.postcode;

            this.address = aboutAffiant.inCareOf?.length > 0 ? ('Care of ' + addressText) : addressText;
        }

    }

    public getServiceInfo() {

        this.servedPersonName = '';
        this.serviceDate = '';
        this.serviceTime = '';
        this.serviceAddress = '';
        this.exhibitList = [];

        this.idMethod = '';
        this.idMethodComment = '';

        if (this.result?.aboutServiceApspSurvey) {

            const serviceData: aboutServiceApspDataInfoType = this.result.aboutServiceApspSurvey;

            this.servedPersonName = serviceData.ServedPersonName ? Vue.filter('getFullName')(serviceData.ServedPersonName) : '';

            if (serviceData.dateTimeServed) {
                this.serviceDate = Vue.filter('beautify-date')(serviceData.dateTimeServed);
                this.serviceTime = Vue.filter('convert-date-time24to12')(serviceData.dateTimeServed);
            }

            if (serviceData.locationServed) {

                const addressInfo = serviceData.locationServed
                const addressText = addressInfo.street + ', '
                    + addressInfo.city + ', '
                    + addressInfo.state + ', '
                    + addressInfo.country + ', '
                    + addressInfo.postcode;
                this.serviceAddress = addressText;
            }

            this.exhibitList = serviceData.documentListApsp ? serviceData.documentListApsp : [];

            this.idMethod = serviceData.idMethod ? serviceData.idMethod : '';
            this.idMethodComment = (this.idMethod == 'other' && serviceData.idMethodComment) ? serviceData.idMethodComment : '';

        }

    }

}
